<template>
    <div class="saas-cgvu px-2 pt-2 pb-0">
        <!-- Loader -->
        <preloader :display="loading" />

        <!-- Header -->
        <header class="header px-1 flex-column mb-3">
            <SaasIcon
                icon="svgLogoSellsyText"
                :width="128"
                :height="28"
                class="logo secondary-blue"
            />
            <a v-if="isAcceptedTerms" class="back-link grey-link semibold fs-3 flex-level" href="/"
                ><i class="el-icon-arrow-left semibold"></i>Retour</a
            >
        </header>

        <!-- Content -->
        <div class="container m-auto">
            <h1 :class="{ 'mb-5': !isAcceptedTerms }">
                {{ $l10n.__('Conditions Générales de Vente et d’Utilisation (CGVU)') }}
            </h1>
            <el-alert
                v-if="isAcceptedTerms"
                class="cgvu-accepted-message p-2 mb-5 primary-05-bkg gray-100 fs-3 b-1-primary-10"
                :title="acceptedTermsMessage"
                type="info"
                :closable="false"
            ></el-alert>
            <embed
                class="pdf-embed"
                :class="{ 'cgvu-accepted': isAcceptedTerms }"
                v-if="terms.url"
                :src="`${terms.url}#zoom=80`"
                type="application/pdf"
            />
        </div>
    </div>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import CgvuApi from 'api/terms/cgvu.js';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    name: 'Cgvu',
    components: {
        SaasIcon,
        Preloader,
    },
    props: {
        corporation: {
            type: String,
            required: true,
        },
        terms: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        redirect: {
            type: String,
            required: false,
            default: '/home',
        },
    },
    data() {
        return {
            loading: false,
            isCheckedTerms: false,
        };
    },
    computed: {
        /**
         * Return True if terms have been accepted
         *
         * @returns {Boolean}
         */
        isAcceptedTerms() {
            return this.terms.status === 'accepted';
        },
        /**
         * Return an informative message when the terms have been accepted
         * With date of acceptance as well as name and email of user
         *
         * @returns {String}
         */
        acceptedTermsMessage() {
            return this.$l10n.__('Acceptées le %(date)s par %(name)s  — %(email)s', {
                date: moment(this.terms.created).format('MMMM Do YYYY à h:mm'),
                name: this.terms.acceptor?.name || 'N/C',
                email: this.terms.acceptor?.email || 'email N/C',
            });
        },
    },
    methods: {
        /**
         * Call back to accept terms
         * If everything is ok, we redirect the user
         *
         * @returns {void}
         */
        acceptTerms() {
            this.loading = true;

            CgvuApi.acceptTerms(this.type, this.terms.version)
                .then((res) => {
                    if (!!res.error) throw err;
                    window.location.href = this.redirect;
                })
                .catch((err) =>
                    Push.error(
                        this.$l10n.__(
                            'Problème lors de la validation des conditions générales, veuillez réessayer',
                        ),
                    ),
                )
                .finally(() => (this.loading = false));
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';

.saas-cgvu {
    // Header
    .header {
        .back-link {
            height: 20px;
        }
    }
    // Content
    .container {
        width: 820px;

        .cgvu-accepted-message {
            .el-alert__title {
                font-size: $font-size;
                line-height: $font-size;
            }
        }
        .pdf-embed {
            width: 100%;
            height: calc(100vh - 147px);

            &.cgvu-accepted {
                height: calc(100vh - 195px);
            }
        }
    }
    // Footer
    .fixed-footer {
        box-shadow: 0px 0px 12px rgba(17, 17, 17, 0.24);

        .el-checkbox__input {
            display: flex;
            align-items: center;
            height: $very-big-font-size;
        }
        .el-checkbox__label {
            white-space: initial;
            font-size: $font-size;
            line-height: $very-big-font-size;
        }
        .el-button {
            border: 0;
            &.is-disabled {
                background-color: $gray-05;
                color: $gray-60;
            }
        }
    }
}
</style>
